<div class="athlete-answer">
    <h3 class="question-title">{{ data[0].questionTitle }}</h3>
    <h4 class="question-help">{{ data[0].questionHelp || '' }}</h4>

    <div class="answer" *ngFor="let d of data">
        <p>{{ d.answerLabel }} / 10</p>
    </div>
</div>
